import React, { FC, memo } from 'react'
import { Heading } from '@ucheba/ui/components/Heading/desktop'
import { Collapse, CollapseItem } from '@ucheba/ui/components/Collapse/desktop'
import { List, ListItem } from '@ucheba/ui/components/List/desktop'
import { Button } from '@ucheba/ui/components/Button/desktop'
import { getTextWithBrs } from '../../../../../utils/helpers/getTextWithBrs'

interface ITipsBlockProps {
  title: string
  list: {
    title: string
    description: string[]
    list: string[]
    buttonText?: string
  }[]
  handleClickRequest: () => void
}

const TipsBlock: FC<ITipsBlockProps> = (props) => {
  const { title, list, handleClickRequest } = props

  return (
    <div itemScope itemType='https://schema.org/FAQPage'>
      <Heading h1={title} as='h2' spacing='large' color='black' />

      <Collapse>
        {list.map((item) => (
          <CollapseItem
            itemScope=''
            itemProp='mainEntity'
            itemType='https://schema.org/Question'
            key={item.title}
            title={
              <h3
                itemProp='name'
                style={{
                  fontSize: `24px`,
                  lineHeight: `24px`,
                  fontWeight: `bold`,
                }}
              >
                {item.title}
              </h3>
            }
          >
            <div itemScope itemProp='acceptedAnswer' itemType='https://schema.org/Answer'>
              <p
                itemProp='text'
                dangerouslySetInnerHTML={{
                  __html: getTextWithBrs(item.description, 2),
                }}
              />
            </div>

            {item?.list && (
              <List view='dots' spacing='xxsmall'>
                {item.list.map((el, index) => (
                  <ListItem key={index}>{el}</ListItem>
                ))}
              </List>
            )}

            <Button onClick={handleClickRequest} color='blue' view='link'>
              {item.buttonText || 'Записаться на консультацию'}
            </Button>
          </CollapseItem>
        ))}
      </Collapse>
    </div>
  )
}

export default memo(TipsBlock)
